export default __webpack_public_path__ + "3d53cbfa667f6e87bac72eadd23f7cf3.ttf";